/**
 * Doctor pending verification screen - shown after registration until admin approves.
 */
import React, { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../../contexts/NotificationsContext';
import toast from 'react-hot-toast';

const DoctorPending = () => {
  const { logout, refreshRole } = useAuth();
  const navigate = useNavigate();
  const { on } = useNotifications();

  // Auto-redirect the moment admin approves — no manual check needed
  useEffect(() => {
    return on('doctor_verified', () => {
      toast.success('Your account has been verified! Redirecting...');
      navigate('/doctor/dashboard', { replace: true });
    });
  }, [on, navigate]);

  const handleCheckStatus = async () => {
    try {
      const role = await refreshRole();
      if (role === 'doctor') {
        navigate('/doctor/dashboard');
      }
    } catch {}
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-yellow-50 flex items-center justify-center px-6">
      <div className="card max-w-md w-full text-center">
        <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Verification Pending</h1>
        <p className="text-gray-500 mb-6">
          Your registration has been submitted successfully. Our admin team is currently reviewing your credentials and KMPDB license. 
          This typically takes 24-48 hours.
        </p>

        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6 text-sm text-gray-700">
          <p className="font-medium text-amber-800 mb-1">What happens next?</p>
          <ul className="text-left space-y-1 list-disc list-inside">
            <li>Admin reviews your license credentials</li>
            <li>You'll receive an SMS notification</li>
            <li>Once approved, you can start consultations</li>
          </ul>
        </div>

        <div className="space-y-3">
          <button onClick={handleCheckStatus} className="btn-primary w-full">
            Check Verification Status
          </button>
          <button
            onClick={async () => { await logout(); navigate('/'); }}
            className="btn-secondary w-full"
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default DoctorPending;
